import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { element } from 'protractor';
import { GeneralService } from './../../services/admin/general.service';
import { UploadComplementComponent } from './../upload-complement/upload-complement.component';
import { ECService } from './../../services/invoices-ec/ec.service';
import { Component, OnInit, ViewChild, TemplateRef, ViewEncapsulation, Input, NgModule } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { JSONP_ERR_WRONG_METHOD } from '@angular/common/http/src/jsonp';
import { UploadECComponent } from './upload-ec/upload-ec.component';
import { CatalogsService } from './../../services/catalogs/catalogs.service';
import { ToasterModule, ToasterService, Toast, ToasterConfig } from 'angular5-toaster';
import { StorageService } from '../../services/storage.service';
import { User } from '../../models/user';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { distinctUntilChanged, debounceTime, switchMap, tap, catchError } from 'rxjs/operators';
import { concat } from 'rxjs/observable/concat';
import { of } from 'rxjs/observable/of';
import 'rxjs/add/operator/map';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-invoices-ec',
  templateUrl: './invoices-ec.component.html',
  styleUrls: ['./invoices-ec.component.scss'],
  providers: [GeneralService, CatalogsService, ECService]
})
export class InvoicesECComponent implements OnInit {

  @Input() entradasMercanciaSeleccionadas;
  @Input() ordenesCompraSeleccionadas;
  @Input() paisUsuario;
  @Input() cerrarModal;
  @ViewChild('myTable') table: any;
  @ViewChild('detailsTemplate') detailsTemplateRef: TemplateRef<any>;
  @Input() messages: any = {
    emptyMessage: '',
    totalMessage: '',
    selectedMessage: ''
  };
  public user: User;
  proveedores: CatalogsService;
  mostrarBtn = false;
  sociedades;
  ordenCompra;
  orden;
  verDetalle = false;
  entradaMercancia;
  entradas = [];
  rows = [];
  importeTotal = 0;
  claveMoneda = '';
  cantidad = 0;
  objEntradas = [];
  objOrdenesC = [];
  fPaginaField = 1;
  cantidadFacturas = 0;
  objLength = [];
  modalFilters;
  rol;
  btnFiltros;
  tipo;
  paisProveedor;
  listaProveedores;

  orden_compra = {
    idOrdenCompra: 0,
    condPago: '',
    idProveedor: '',
    moneda: '',
    sociedad: 0,
    flag: '',
    importeFactura: '',
    tipoDeImputacion: '',
    totalOc: '',
    indicadorWebre: '',
    centro: '',
    wo_em: '',
    dummy_rfc: '',
    dummy_nombre: ''
  };

  proveedorFilter;
  sociedadFilter;
  ordenCompraFilter;

  closeResult: string;
  busy = false;
  busyListado = false;
  busyBusqueda = false;
  busyEM = false;

  proveedores$: Observable<any>;
  proveedoresLoading = false;
  proveedorinput$ = new Subject<string>();

  flagBtnCargar = false;
  flagDatos = false;
  flagEntradas;
  flagBuscar;
  flagMensaje;
  toastMessage;
  mensajeCargarMas = false;
  valueOrdenCompra;
  l: any = 0;
  tipoProveedor;

  public toasterconfig: ToasterConfig =
    new ToasterConfig({ timeout: 500 });

  constructor(
    private translate: TranslateService,
    private general: GeneralService,
    private storageService: StorageService,
    public catalogs: CatalogsService,
    private ecService: ECService,
    private modalService: NgbModal,
    private toasterService: ToasterService,

  ) {
    this.loadProyectos();

    this.translate.get('texto.noHayInformacionLabel').subscribe(
      text => {
        this.messages.emptyMessage = text;
      });

    this.translate.get('texto.totalLabel').subscribe(
      text => {
        this.messages.totalMessage = text;
      });

    this.translate.get('texto.seleccionadoLabel').subscribe(
      text => {
        this.messages.selectedMessage = text;
      });

    this.translate.get('texto.toastSeleccionarEntradas').subscribe(
      text => {
        this.toastMessage = text;
      });

  }

  ngOnInit() {
    this.noBack();
    this.user = this.storageService.getCurrentUser();
    this.rol = this.user.rol.id;
   
    this.modulo();
    if (this.rol === 3) {
      //  this.getOrdenesCompra();
      this.paisProveedor = this.user.pais;
      this.flagEntradas = false;
      this.btnFiltros = true;
    } else {
      this.getProveedores();
      this.flagEntradas = true;
      this.btnFiltros = false;
    }
    // this.getSociedades();
  }

  noBack() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }

  modulo() {
    this.general.serviceLog('Facturas de extra costos').subscribe(
      data => {
        // console.log(data);
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        }
      },
    );
  }

  loadProyectos() {
    this.proveedores$ = concat(of([]),
      this.proveedorinput$.pipe(
        debounceTime(200),
        distinctUntilChanged(),

        tap(() => this.proveedoresLoading = true),
        switchMap(term =>
          this.catalogs.obtenerProveedoresBusqueda(term).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => this.proveedoresLoading = false)
          ))
      )
    );
  }

  toggleExpandRow(row) {
    this.table.rowDetail.toggleExpandRow(row);
  }

  getProveedores() {
    this.busy = true;
    this.catalogs.obtenerProveedores().subscribe(
      data => {
        this.busy = false;
        this.listaProveedores = data.sapProveedor;

      },
      err => {
        // console.log(err);
      },
    );
  }

  getSociedades() {
    this.busy = true;
    this.catalogs.obtenerSociedades().subscribe(
      data => {
        this.busy = false;
        this.sociedades = data.sapSociedad;

      },
      err => {
        // console.log(err);
      },
    );
  }

  tProveedor(e) {
    if (this.proveedorFilter == null) {
      this.valueOrdenCompra = '';
    }

    this.objLength = [];
    this.rows = [];
    this.cantidadFacturas = 0;
    this.importeTotal = 0;

    if (e) {
      this.paisProveedor = e.pais;
    }
    
  }

  selecciones(index, row) {
    this.objLength = [];
    if (this.entradaMercancia[index].selected) {
      this.entradaMercancia[index].selected = false;
    } else {

      this.entradaMercancia[index].selected = true;

      for (const iterator of this.entradaMercancia) {
        if (iterator != this.entradaMercancia[index] && iterator.selected === true) {
            iterator.selected = false;
        }
      }

    }

    if (this.entradaMercancia && this.entradaMercancia.length > 0) {
      for (let i = 0; i < this.entradaMercancia.length; i++) {
        if (this.entradaMercancia[i].selected) {
          this.objLength.push(this.entradaMercancia[i]);
        }
      }
    }

    this.cantidadFacturas = this.objLength.length;
  }

  seleccion(i) {
    const btn = document.getElementById('item');
    if (btn !== i) {
      btn.classList.add('item-color');
    }
  }


  getEntradasMercancia() {
    this.busyEM = true;
    this.verDetalle = true;
    this.importeTotal = 0;
    this.cantidad = 0;
    this.entradas = [];
    this.orden = this.valueOrdenCompra;
    const rol = this.user.rol.id;
    let userProveedorId;
    this.objLength = [];
    this.cantidadFacturas = this.objLength.length;
    var total;

    if (rol === 3) {
      userProveedorId = this.user.id;
    } else {
      if (this.proveedorFilter !== 'undefined' || this.proveedorFilter !== '') {
        userProveedorId = this.proveedorFilter;
      }
    }


    this.ecService.obtenerEntradasMercancia(this.orden, userProveedorId).subscribe(
      // tslint:disable-next-line:no-shadowed-variable
      data => {
        this.busyEM = false;
        if (data != null) {
          this.entradaMercancia = data.results;
          this.rows = this.entradaMercancia; 

          for (let i = 0; i < this.rows.length; i++) {
            total = parseFloat(this.rows[i].importe);
            this.importeTotal += total;
          }
        }


      },
      err => {
        this.busyEM = false;
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );
  }

  open(content) {

    if (this.objLength.length > 0) {
      const modalRef = this.modalService.open(UploadECComponent, { size: 'lg', keyboard: false, backdrop: 'static' });
      modalRef.componentInstance.entradasMercanciaSeleccionadas = this.objLength;
      modalRef.componentInstance.totalOC = this.importeTotal;
      modalRef.componentInstance.paisUsuario = this.paisProveedor;
      if (this.rol === 2) {
        modalRef.componentInstance.proveedor = this.proveedorFilter;
      }
      //   modalRef.componentInstance.cerrarModal = modalRef.close(); 
      modalRef.result.then((result) => {
        if (result === 'cancelar') {
          // console.log('cancelo envio');
        } else {
          this.objLength = [];
          this.cantidadFacturas = 0;
          this.verDetalle = false;
          this.rows = [];
          this.valueOrdenCompra = null;
          modalRef.close();
        }
      }).catch((error) => {
        // console.log(error);
      });
    } else {
      this.toasterService.pop('error', 'ERROR', this.toastMessage);
    }

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  openFilters(filtersOC) {
    this.flagBuscar = false;
    this.modalFilters = this.modalService.open(filtersOC, { centered: true });
    this.modalFilters.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReasonFiltersOC(reason)}`;
    });
  }

  private getDismissReasonFiltersOC(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }




}



// WEBPACK FOOTER //
// ./src/app/pages/invoices-ec/invoices-ec.component.ts